export const reservationStatus = {
  RESERVED: "Reservado",
  CHECKIN: "Checkin",
  CHECKOUT: "Checkout",
  COMPLETED: "Completado",
  ARCHIVED: "Archivado",
};
